import styles from "./Radio.module.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { fas } from "@fortawesome/pro-solid-svg-icons";
import { library } from '@fortawesome/fontawesome-svg-core'
library.add(fas);

const uncheckedRadio = <FontAwesomeIcon icon={["fas", "circle"]} className={`${styles.customRadio} ${styles.customRadioUnchecked}`} />;
const checkedRadio = <FontAwesomeIcon icon={["fas", "circle-dot"]} className={`${styles.customRadio} ${styles.customRadioChecked}`} />;

function Radio({ checked, name, value, onChange, onClick }) {
    return (
        <span className={styles.radioContainer} onClick={onClick}>
            <input type="radio" name={name} value={value} className={styles.radio} />
            {checked ? checkedRadio : uncheckedRadio}
            <FontAwesomeIcon icon={["fas", "circle"]} className={styles.customRadioBg} />
        </span>
    )
}

export default Radio;